import { FC, SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement>

const NexaAIIcon: FC<Props> = (props) => (
  <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.80521 8.84981C3.18675 5.36966 8.06533 0 8.06533 0C0.3429 0.898826 -2.98656 10.7858 3.27924 15.8791L3.3255 14.0584C4.52779 15.3952 6.00762 15.5104 6.00762 15.5104C5.05962 14.7268 5.05962 12.9753 5.05962 12.9753C6.58563 14.6807 8.22712 14.0584 8.22712 14.0584C6.30804 13.4362 6.44673 11.4772 6.44673 11.4772C9.79925 12.0533 9.66061 14.4041 9.66061 14.4041C8.55076 17.6998 4.66643 16.847 4.66643 16.847C9.33694 19.6816 15.6258 16.9852 17.4064 12.0763C19.2098 7.19045 16.759 1.33647 12.0191 2.4428C11.9035 1.40575 13.1057 0.576022 13.1057 0.576022C10.3775 1.45183 10.5624 2.74235 10.5624 2.74235L9.61441 1.49784L9.84561 3.59505L9.2676 6.03795C9.82252 7.76648 10.9092 7.21334 11.5797 5.8536C15.5799 5.09302 13.8919 11.5921 8.80511 8.84969L8.80521 8.84981Z"
      fill="currentColor"
    />
  </svg>
)

export default NexaAIIcon
